import type { SupportChatFeatureConfig } from './type';
import { SupportChatExternalAuthorizationMethod, SupportChatLanguage } from './type';

export const supportChat: Partial<SupportChatFeatureConfig> = {
    channelId: 'george-bcr-ada',
    externalAuthorizationMethod:
        SupportChatExternalAuthorizationMethod.TOKEN_EXCHANGE_INVALIDATION_POST,
    externalAuthorizationTokenExchangeKeepAccessTokenInCookie: true,
    fallbackLanguage: SupportChatLanguage.RO,
    languagePackage: 'george-ro',
    supportedLanguages: [SupportChatLanguage.EN, SupportChatLanguage.RO],
    useInvalidationWhenSessionExpired: true,
    displayChatStatus: true,
    proactiveChatChannelId: 'heygeorge-ro-web',
};
